module.exports = __webpack_public_path__ + "img/postgresql.f764e24c.svg";